import { ChangeDetectionStrategy, Component, InputSignal, OutputEmitterRef, input, output } from '@angular/core';

import { FilterSelectionOption, MultiSelectionGroupComponent } from '@core/ui';
import { AddressType, addressTypeDescriptions } from '@mp/organization-master-data/addresses/domain';
import { ADDRESS_TYPES_PRIORITY_ORDER } from '@mp/organization-master-data/addresses/util';

@Component({
  selector: 'mpomd-address-list-filter',
  templateUrl: './address-list-filter.component.html',
  styleUrl: './address-list-filter.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MultiSelectionGroupComponent],
})
export class AddressListFilterComponent {
  readonly hidden: InputSignal<boolean> = input<boolean>(false);

  readonly filterChange: OutputEmitterRef<AddressType[]> = output<AddressType[]>();

  protected readonly options: FilterSelectionOption<AddressType>[] = ADDRESS_TYPES_PRIORITY_ORDER.map((option) => ({
    value: option,
    label: addressTypeDescriptions[option],
  }));
}
